import React, { ReactElement, isValidElement, Fragment } from "react";
import { FormattedMessage } from "react-intl";

import { ModalDialog, MODAL_WINDOW_TITLE_ID } from "@sportal/cdk/modal";
import { UnstyledButton } from "@sportal/cdk/unstyledButton/UnstyledButton";
import "./MobileActionDialog.scss";

interface ActionItem {
  onClick: () => void;
  id: string;
  className?: string;
  content: string | ReactElement;
}

interface MobileActionDialogProps {
  headerText: string | ReactElement;
  items: ActionItem[] | ReactElement[];
  onClose: () => void;
}

export const MobileActionDialog = ({
  headerText,
  items,
  onClose,
}: MobileActionDialogProps) => {
  return (
    <ModalDialog className="mobile-actions-dialog">
      <ModalDialog.Header>
        <h3 id={MODAL_WINDOW_TITLE_ID} className="header-text">
          {headerText}
        </h3>
      </ModalDialog.Header>

      <ModalDialog.Body>
        {items.map((item, index) =>
          isValidElement(item) ? (
            <Fragment key={index}>{item}</Fragment>
          ) : (
            <UnstyledButton
              key={item.id}
              className={item.className}
              onClick={item.onClick}
              id={item.id}
            >
              {item.content}
            </UnstyledButton>
          )
        )}
      </ModalDialog.Body>

      <ModalDialog.Footer>
        <UnstyledButton onClick={onClose}>
          <FormattedMessage id="dismiss" />
        </UnstyledButton>
      </ModalDialog.Footer>
    </ModalDialog>
  );
};
